import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/accedi", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const pending = sessionStorage.getItem("pending_checkout");
        if (pending) {
          sessionStorage.removeItem("pending_checkout");
          try {
            const p = JSON.parse(pending);
            const { data: co } = await api.post("/payments/checkout", {
              ...p,
              origin_url: window.location.origin,
            });
            window.location.href = co.checkout_url;
            return;
          } catch (e) {
            toast.error(formatApiError(e));
          }
        }
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate("/accedi", { replace: true });
      }
    })();
  }, []);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen grid place-items-center bg-[#FAF8F5]">
      <div className="text-center">
        <Loader2 size={28} className="animate-spin text-[#E05638] mx-auto" />
        <p className="mono-label text-neutral-500 mt-4">Accesso con Google in corso…</p>
      </div>
    </div>
  );
}
